
import {Component, Prop, Vue} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import PriceHelper from "../../../../../../admin/js/helpers/priceHelper";
@Component({
  name: 'catalog-product-price'
})

export default class ProductPrice extends mixins(PriceHelper) {
  @Prop({default: () => []}) private productData: Array<object>;

  private get totalPrices(): number {
    return this.$store.getters['CatalogProduct/totalPrices'];
  }

  private get promotionEndTime(): string {
    if (this.productData['special_price_end_date'] || null) {
      let date = new Date(this.productData['special_price_end_date']);

      return date.toLocaleDateString('nl-NL');
    }

    return  '';
  }

  private get fromPrices(): number {
    return this.$store.getters['CatalogGroupedProduct/fromPrices'];
  }

}
